// extracted by mini-css-extract-plugin
module.exports = {"container":"DeckOverlay_container__3_yzi","modal":"DeckOverlay_modal__12TNx"};